import React from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import { Offcanvas, Table } from "react-bootstrap";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import MainInput from "../Components/MainInput";
import TableBtns from "../Components/TableBtns";
import AdminsHook from "../hooks/MangmentHooks/AdminsHook";
import MainDropdown from "../Components/MainDropdown";
import Shimmer from "../Components/Shimmer";
import Pagination from "../Components/Pagination";
import yes from "../assets/icons/yes.png";
import error from "../assets/icons/error.png";
import { ADMIN_PAGE_LABELS } from "../navigation/adminNavigation";

const Admins = () => {
  const {
    NavItems,
    setSearch,
    selectedTeamName,
    show,
    handleClose,
    handleSelect,
    handleNextPage,
    handlePrevPage,
    totalPages,
    currentPage,
    admins,
    loading,
    permissionGroup,
    handleSubmit,
    formData,
    setFormData,
    handleDelete,
    handleEditAdmin,
    handleAddNewAdmin,
    isEditMode,
    handleBlock,
    addLoading,
    blockLoading,
    deleteLoading,
    handleResendInvitation,
    resendLoading
  } = AdminsHook();

  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center">
          <PagesNav links={NavItems} />
          <div className="d-flex gap-2">
            <SearchInput search={(e) => setSearch(e.target.value)} />
            <AddInput onClick={handleAddNewAdmin} />
          </div>
        </div>

        <Table hover className="text-center">
          <thead>
            <tr>
              <th className="bg-light">Name</th>
              <th className="bg-light">Email</th>
              <th className="bg-light">{ADMIN_PAGE_LABELS.role}</th>
              <th className="bg-light">Verified</th>
              <th className="bg-light">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading && <Shimmer type={"table"} colSpan={5} />}
            {admins?.map((admin) => (
              <tr key={admin._id}>
                <td>{admin.firstName + " " + admin.lastName}</td>
                <td>{admin.email}</td>
                <td>{admin?.permissionGroup?.name}</td>
                <td>
                  {admin.isVerified ? (
                    <img src={yes} alt="Verified" />
                  ) : (
                    <img src={error} alt="Not verified" />
                  )}
                </td>
                <td>
                  <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                    <TableBtns
                      blockloading={blockLoading[admin._id]}
                      deleteloading={deleteLoading[admin._id]}
                      onClickBlock={() => handleBlock(admin._id)}
                      isBlocked={Boolean(admin?.isBlocked)}
                      blockbtn={true}
                      onClickEdit={() => handleEditAdmin(admin._id)}
                      onClickDelete={() => handleDelete(admin._id)}
                    />
                    {!admin.isVerified && !admin.isBlocked ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        disabled={Boolean(resendLoading[admin._id])}
                        onClick={() => handleResendInvitation(admin._id)}
                      >
                        {resendLoading[admin._id]
                          ? "Sending invitation"
                          : "Resend invitation"}
                      </button>
                    ) : null}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          handleNextPage={handleNextPage}
          handlePrevPage={handlePrevPage}
          totalPages={totalPages}
          currentPage={currentPage}
        />
      </MainContainer>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>
            {isEditMode ? "Edit Admin" : "Create New Admin"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <div>
            {!isEditMode && (
              <>
                <MainInput
                  label={"First Name*"}
                  placeholder={"Enter First Name....."}
                  required={true}
                  type={"text"}
                  value={formData.firstName}
                  onChange={(e) =>
                    setFormData({ ...formData, firstName: e.target.value })
                  }
                />
                <MainInput
                  label={"Last Name*"}
                  placeholder={"Enter Last Name....."}
                  required={true}
                  type={"text"}
                  value={formData.lastName}
                  onChange={(e) =>
                    setFormData({ ...formData, lastName: e.target.value })
                  }
                />
                <MainInput
                  label={"Email"}
                  placeholder={"Enter Email....."}
                  required={true}
                  type={"Email"}
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </>
            )}

            <MainDropdown
              label={ADMIN_PAGE_LABELS.role}
              title={
                selectedTeamName
                  ? selectedTeamName
                  : ADMIN_PAGE_LABELS.selectRole
              }
              options={permissionGroup}
              langDir="en"
              onSelect={handleSelect}
              displayKey="name"
            />
          </div>

          <div className="d-flex justify-content-center align-items-center pb-3">
            <button
              onClick={handleSubmit}
              className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
            >{addLoading?  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>:
              isEditMode ? "Update" : "Submit"}
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Admins;
